import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContactForm from "../ContactForm/ContactForm";
import "./ContactFormModal.css";

function ContactFormModal({ open, onClose }) {
  return (
    <div className="formMod">
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogContent className="frMCon">
         
          <h2 className="modalTitle">Get in Touch</h2>
          <p className="modalSub">Submit the form, and our team will reach out to you.</p>

          <IconButton
            onClick={onClose}
            className="closeBtn"
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              width: 45,
              height: 45,
              color: "#000",
              borderRadius: "50%",
              "&:hover": { backgroundColor: "#EC5E21", color: "#fff" },
              "& svg": { fontSize: 28 }
            }}
          >
            <CloseIcon />
          </IconButton>

         
          <ContactForm onClose={onClose} />
        </DialogContent>
      </Dialog>
    </div>
  );
}

ContactFormModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

ContactFormModal.defaultProps = {
  open: false,
  onClose: undefined,
};

export default ContactFormModal;
